<template>
  <div class="container mx-auto px-4 h-full">
    <div class="flex content-center items-center justify-center h-full">
      <div class="w-full lg:w-6/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-300 border-0"
        >
          <div class="rounded-t mb-0 px-6 py-6">
            <div class="text-center mb-3">
              <h6 class="text-gray-600 text-sm font-bold">
                Sign up with
              </h6>
            </div>
            <div class="btn-wrapper text-center">
              <button
                class="bg-white active:bg-gray-100 text-gray-800 font-normal px-4 py-2 rounded outline-none focus:outline-none mr-2 mb-1 uppercase shadow hover:shadow-md inline-flex items-center font-bold text-xs ease-linear transition-all duration-150"
                type="button"
              >
                <img alt="..." class="w-5 mr-1" :src="github" />
                Github
              </button>
              <button
                class="bg-white active:bg-gray-100 text-gray-800 font-normal px-4 py-2 rounded outline-none focus:outline-none mr-1 mb-1 uppercase shadow hover:shadow-md inline-flex items-center font-bold text-xs ease-linear transition-all duration-150"
                type="button"
              >
                <img alt="..." class="w-5 mr-1" :src="google" />
                Google
              </button>
            </div>
            <hr class="mt-6 border-b-1 border-gray-400" />
          </div>
          <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
            <div class="text-gray-500 text-center mb-3 font-bold">
              <small>Or sign up with credentials</small>
            </div>
            <div v-if="alertOpen" class="text-white px-6 py-4 border-0 rounded relative mb-4 bg-red-500">
              <span class="text-xl inline-block mr-2 align-middle">
                <i class="fas fa-bell"></i>
              </span>
              <span class="inline-block align-middle mr-8">
                <b class="capitalize">Oops!</b> {{ notif }}
              </span>
              <button class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 pr-4 outline-none focus:outline-none" v-on:click="alertOpen = false">
                <span>×</span>
              </button>
            </div>
            <div v-if="notifOpen" class="text-white px-6 py-4 border-0 rounded relative mb-4 bg-green-500">
              <span class="text-xl inline-block mr-2 align-middle">
                <i class="fas fa-bell"></i>
              </span>
              <span class="inline-block align-middle mr-8">
                <b class="capitalize"></b> {{ notif }}
              </span>
              <button class="absolute bg-transparent text-2xl font-semibold leading-none right-0 top-0 mt-4 mr-6 pr-4 outline-none focus:outline-none" v-on:click="notifOpen = false">
                <span>×</span>
              </button>
            </div>
            <form @submit.prevent="handleRegister">
              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Name
                </label>
                <input
                  type="text"
                  v-model="user.username"
                  class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  placeholder="Name"
                />
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Email
                </label>
                <input
                  type="email"
                  v-model="user.email"
                  class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  placeholder="Email"
                />
              </div>

              <div class="relative w-full mb-3">
                <label
                  class="block uppercase text-gray-700 text-xs font-bold mb-2"
                  htmlFor="grid-password"
                >
                  Password
                </label>
                <input
                  type="password"
                  v-model="user.password"
                  class="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                  placeholder="Password"
                />
              </div>

              <div>
                <label class="inline-flex items-center cursor-pointer">
                  <input
                    id="customCheckLogin"
                    type="checkbox"
                    class="form-checkbox text-gray-800 ml-1 w-5 h-5 ease-linear transition-all duration-150"
                  />
                  <span class="ml-2 text-sm font-semibold text-gray-700">
                    I agree with the
                    <a href="javascript:void(0)" class="text-green-500">
                      Privacy Policy
                    </a>
                  </span>
                </label>
              </div>

              <div class="text-center mt-6">
                <button
                  class="bg-gray-900 text-white active:bg-gray-700 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                  type="submit"
                >
                  Create Account
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import github from "@/assets/img/github.svg";
import google from "@/assets/img/google.svg";

export default {
  data() {
    return {
      loading: false,
      alertOpen: false,
      notifOpen: false,
      
      notif: '',
      isValid: false,

      github,
      google,

      user: {
        username: '',
        email: '',
        password: ''
      },
    };
  },

  methods: {
    handleRegister () {
      this.loading = true
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.user.email && this.user.password) {
            this.$store.dispatch('auth/register', this.user).then(
              () => {
                this.alertOpen = false
                this.notifOpen = true
                // this.$router.push({ name: 'Dashboard' })
                this.notif = 'Silahkan tunggu konfirmasi dari kami'
                this.user = {}
              },
              error => {
                this.loading = false
                this.alertOpen = true
                this.notifOpen = false
                this.notif =
                  (error.response && error.response.data) ?
                  error.response.data.error.message :
                  error.toString()
              },
            )
          }
        } else {
          this.loading = false
          this.alertOpen = true
          this.notifOpen = false
          this.notif = 'Input is not valid'
        }
      })
    },
  }
};
</script>
